import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { LicenseEnv } from '../types';
import { getLicenseBaseUrl } from '../services/api';
import './LoginScreen.css';

interface LoginScreenProps {
  onLoginSuccess: () => void;
}

const LoginScreen: React.FC<LoginScreenProps> = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [env, setEnv] = useState<LicenseEnv>('PROD');
  const [error, setError] = useState('');
  const { login, isLoading } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('Please enter both username and password');
      return;
    }

    const success = await login(
      {
        user_name: username,
        password: password,
      },
      env
    );

    if (success) {
      onLoginSuccess();
    } else {
      setError('Invalid credentials. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>RainMaker Admin</h1>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Environment</label>
            <div className="env-toggle">
              {(['PROD', 'DEV'] as LicenseEnv[]).map((e) => (
                <button
                  key={e}
                  type="button"
                  className={`env-toggle-option env-toggle-${e.toLowerCase()} ${env === e ? 'selected' : ''}`}
                  onClick={() => setEnv(e)}
                  disabled={isLoading}
                >
                  {e}
                </button>
              ))}
            </div>
            <p className="env-toggle-url">{getLicenseBaseUrl(env)}</p>
            {env === 'DEV' && (
              <p className="env-toggle-note">
                DEV-only session: only the DEV license API is contacted. Quota &amp; SAR (prod) are
                disabled until you sign in as PROD.
              </p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              disabled={isLoading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button
            type="submit"
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;